import { Component } from '@angular/core';
import { environment } from '@env';
import { COMPANY_EMAIL } from '@core/constants';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent {
  domainPrefix: string = environment.production ? '' : `${environment.name}-`;

  myHivve = `${this.domainPrefix}myhivve.com`;
  trackImpact = `${this.domainPrefix}trackimpact.org`;
  impactTracker = `tracker.hivveimpact.com`;
  impactTrackerAu = `trackerau.hivveimpact.com`;
  hivveImpactTracker = `${this.domainPrefix}hivveimpacttracker.com`;
  companyUrl = `hivve.tech`;
  companyEmail = COMPANY_EMAIL;
  companyContactUrl = `${this.companyUrl}/contact-us`;
  companyTermsUrl = `${this.companyUrl}/terms-and-conditions`;
}
